<header>
  <h2 class="heading-underline">ADC Migration: {{fields.length}} fields</h2>
  <mat-icon (click)="refresh()" class="refresh" matTooltip="Refresh the list" matTooltipPosition="left">refresh</mat-icon>
</header>

<table>
  <tbody>
    @for (field of fields; track field.index) {
      <tr>
        <!--    <td>{{field.meta.status !== FieldMetaStatus.MIGRATED ? '#' + field.index : ''}}</td>-->
        <td class="expression" (click)="navigateToField(field)" [colSpan]="field.status === FieldMetaStatus.MIGRATABLE? 1 : 2">
          <div [style.text-decoration-line]="field.status === FieldMetaStatus.COMPLETED ? 'line-through' : ''">{{field.expression}}</div>
          <div [style.color]="statusColours[field.status]">{{field.description}}</div>
        </td>
        @if (field.status === FieldMetaStatus.MIGRATABLE) {
          <td class="migrate">
            <button theme="small"
              (click)="migrateFields([field])" [disabled]="migrationInProgress" matTooltip="Migrate" matTooltipPosition="left"><mat-icon>send</mat-icon></button>
            </td>
          }
          <td class="delete">
            @if (field.status !== FieldMetaStatus.COMPLETED) {
              <button (click)="deleteField(field)" theme="small" [disabled]="migrationInProgress" matTooltip="Delete" matTooltipPosition="left"><mat-icon>delete_forever</mat-icon></button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>

  <div class="migrate-all"><button theme="medium" (click)="migrateAll()" [disabled]="migrationInProgress">Migrate All</button></div>
